/** Shared destination used by desktop and web feedback confirmations. */
export const DICTATION_FEEDBACK_HISTORY_HREF = '/dictation-logs';
